import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { UtilityService } from '../../../services/utility-service';
import { DatePipe, Location } from '@angular/common';
import { TransactionWrapper } from '../../../model/transactionWrapper';
import { TransactionWrapperData } from '../../../model/transactionWrapperData';
import { Constants } from '../../../constants/ebtq-constants';
import { ErrorService } from '../../../shared/error-page/service/error-service';
import { ReverseTransaction } from '../../../model/ReverseTransaction';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {Title} from '@angular/platform-browser';
import { ValidationContextImpl } from '../../../model/validationContextImpl';

@Component({
  standalone: false,
  selector: 'app-query-transaction-details',
  templateUrl: './query-transaction-details.component.html',
  styleUrls: ['./query-transaction-details.component.scss']
})
export class QueryTransactionDetailsComponent implements OnInit {
  cols!: any[];
  containsError = false;
  validationMsg!: string;
  errorMessage: string[] = [];
  data: any;
  keys!: TransactionWrapperData;
  mainPage!: string;
  responseDetails: any;
  navigate!: string;
  routingForCancel!: string;
  transactionId!: string;
  responseTransList: any;
  loanResultKeys: any;
  isReversible = false;
  isFNMAUser = false;
  currentProcessingDate: any;
  reverseClick = false;
  warningMessage!: string;
  clickYes = false;
  yesData: any;
  title = 'Transaction Detail';

  constructor(private activeRouter: ActivatedRoute, private service: ApiService, private routerCore: Router,
              private utilService: UtilityService, public datepipe: DatePipe, private location: Location,
              private errorService: ErrorService, private titleService: Title, private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.fetchRecords();
    sessionStorage.setItem('currentSubMenuOption', 'RMServicing');
    this.warningMessage = '';
    this.cdr.detectChanges();
  }
  fetchRecords(): void {
    this.activeRouter.queryParams.subscribe(params => {
      this. keys = JSON.parse(atob(params.query));
      this.transactionId = params.transactionNumber;
      this.navigate = params.loanNumber;
      this.loanResultKeys = params.loanResult;
      this.mainPage = params.mainPage;
    });
    const transactionWrapper = new TransactionWrapper();
    transactionWrapper.queryServiceName = Constants.GET_TRAN_DETAIL;
    transactionWrapper.parameters = transactionWrapper.parameters ?? [];
    transactionWrapper.parameters[0] = this.transactionId;
    this.errorMessage = [];
    //we need CurrentProcessingDate response for showing is Reversable link, so using switchMap
    // to avoid executeQuery call to happen before getting processingDate response
    this.service.getCurrentProcessingDate().pipe(
      switchMap((d) => {
        this.currentProcessingDate = d.date;
        return this.service.executeQuery(transactionWrapper);
      }), catchError( (err) => {
        this.errorMessage.push(err);
        return of();
      })).subscribe(
      (data: any) => {
        this.yesData = {...data.object};
        this.toShowReversible(data.object);
        this.responseDetails = this.formatloanDetail(data.object);
        this.responseDetails;

        // Commented out as if the Servicer has been transfered, user will not be able to view the transaction details
        //  if (!this.utilService.isUserAuthorizedForServicerNumber(this.responseDetails.ServicerNum)){
        //      this.cancel();
        //     return;
        //   }
        this.cdr.detectChanges();
      },
      error => {
        this.errorMessage.push(error);
        this.cdr.detectChanges();
      }
    );
  }
  reverse() {
    this.reverseClick = true;

    this.warningMessage = Constants.REVERSE_MESSAGE;
  }
 
  toShowReversible(data: any) {
    const date = new Date(this.currentProcessingDate);
    const beginOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const effDate = this.utilService.convertDateToMillisec(data.EffectiveDate);
    const isExternal = JSON.parse(sessionStorage.getItem('isExternal') ?? 'false');

    const tranType = String(data.TranType);
    const actionCode = String(data.ActionCode);
    const tranDesignator = String(data.TranDesignator);
    const reversedFlag = String(data.ReversedFlag);

    if (tranType !== '3' && actionCode !== '103' && actionCode !== '124' &&
      tranDesignator !== '81' && tranDesignator !== '5'
      && reversedFlag !== 'Y' && !(effDate > this.currentProcessingDate)) {
      if (!(effDate < beginOfMonth.getTime() && (actionCode === '70' || actionCode === '71' ||
          actionCode === '72' || actionCode === '31' || actionCode === '32' || actionCode === '33' ||
          actionCode === '34' || actionCode === '35'  || actionCode === '65'
      ) && isExternal )) {
        this.isReversible = true;
      }
    }
  }

  getFirstDayOfMonth(year: number, month: number) {
    return new Date(year, month, 1);
  }
  /** No button - get back to Detail page */
  public No() {
    this.reverseClick = false;
    this.warningMessage = '';
  }
  /** Yes button - get to Sucess Revrse page */
  public Yes() {
    this.reverseClick = true;
    this.clickYes = true;
    this.containsError = false;
    this.errorMessage = [];
    this.validationMsg = '';

    this.service.getTransactionReverse(this.formatYesData()).subscribe(
      (data: TransactionWrapper) => {
        this.checkValidationMessages(data.validationContext ?? {} as ValidationContextImpl);
        this.cdr.detectChanges();
      },
      error => {
        this.clickYes = false;
        this.containsError = true;

        if (Array.isArray(error)) {
          error.forEach(item =>{
            this.errorMessage.push(item);
          });
        } else {
          this.errorMessage.push('Please resubmit your request or contact Production Support.');
        }
        this.cdr.detectChanges();
      }
    );

  }
  checkValidationMessages(vCtx: ValidationContextImpl) {
    let vldMsg:string;
    if (vCtx.errorMessages) {
      vldMsg = '[';
      vCtx.errorMessages.forEach((s: string, i: number) => {
        vldMsg = vldMsg + s;
        if (i < (vCtx.errorMessages?.length ?? 0) - 1 ) {
          vldMsg = vldMsg + ', ';
        }
      });
      vldMsg = vldMsg + ']';
      this.clickYes = false;
      this.containsError = true;
      this.validationMsg = vldMsg;
      return;
    } 
    if (vCtx.warningMessages) {
      vldMsg = '[';
      vCtx.warningMessages.forEach((s: string, i: number) => {
        vldMsg = vldMsg + s;
        if (i < (vCtx.warningMessages?.length ?? 0) - 1 ) {
          vldMsg = vldMsg + ', ';
        }
      });
      vldMsg = vldMsg + ']';
      this.validationMsg = vldMsg;
    } 
    this.warningMessage = 'Following transaction has been successfully reversed.';
  }
  /** cancel button - get back to result page */
  public cancel() {
    // this.location.back();
    this.titleService.setTitle('List of Transactions');
    this.routerCore.navigate(['transactionsResults'], {
      queryParams: { query: btoa(JSON.stringify(this.keys)), navigate:this.navigate, mainPage: this.mainPage, loanResult: this.loanResultKeys}
    });
  }
  /** Detailed page print view*/
  public printComponent() {
    window.print();
  }

  /** Format the API response to readable format */
  formatloanDetail(response: any) {

    this.utilService.productCode.forEach(function(part1, index1, array1) {

      if (array1[index1].value === String(response.ProductType)) {
        response.ProductType = array1[index1].label;
      }
    });

    this.utilService.tranType.forEach(function(part1, index1, array1) {
      if (array1[index1].value === String(response.TranType)) {
        response.TranType = array1[index1].label;
      }
    });

    this.utilService.actionTypeCode.forEach(function(part1, index1, array1) {
      if (array1[index1].value === String(response.ActionCode)) {
        response.ActionCode = array1[index1].label;
      }
    });

    this.utilService.transactionStatus.forEach(function(part1, index1, array1) {
      if (array1[index1].value === String(response.TransStatus)) {
        response.TransStatus = array1[index1].label;
      }
    });
    if (response.ReversedFlag === 'N') {
      response.ReversedFlag = 'No';
    }
    else if (response.ReversedFlag === 'Y') {
      response.ReversedFlag = 'Yes';
    }
    return response;
  }

  formatYesData() :ReverseTransaction {
    const reverseTran = new ReverseTransaction();
    const userId = sessionStorage.getItem('userID');
    reverseTran.actionTypeCode = this.yesData.ActionCode;
    reverseTran.effectiveDate = this.utilService.convertDateToMillisec(this.yesData.EffectiveDate);
    reverseTran.fannieMaeLoanNumber = this.yesData.LoanNum;
    reverseTran.transactionAmount = '' + this.yesData.TransactionAmt * -1;
    reverseTran.servicerNumber = this.yesData.ServicerNum;
    reverseTran.transactionDesignator = this.yesData.TranDesignator;
    reverseTran.originalTransactionID = this.yesData.TranSysKey;
    reverseTran.userId = userId ?? undefined;

    return reverseTran;
  }
}


